import { useQuery } from '@tanstack/react-query';
import { AnalysisResultsForCheckup } from '@companion-professional/dctypes';
import { getMlForCheckup } from '../lib/api';
import { useFeatureFlagEnabled } from 'posthog-js/react';

// useMlForCheckup is a hook that fetches the ML results (if they exist) for a given checkup.  This is controlled using
// the PostHog feature flag `enableAnalysisDisplay`.  If the feature flag is not enabled, then this hook will not
// fetch any ML results and will return an empty object.
export const useMlForCheckup = (checkupId: string) => {
  const enableAnalysisDisplay = useFeatureFlagEnabled('enableAnalysisDisplay');
  const {
    isPending,
    error,
    data: mlForCheckup
  } = useQuery<AnalysisResultsForCheckup>({
    queryKey: ['checkup_ml_results', checkupId],
    queryFn: () => {
      if (!enableAnalysisDisplay) {
        // If the feature flag is not enabled, we return an empty object and do not fetch any ML results.
        return Promise.resolve({} as AnalysisResultsForCheckup);
      }
      return getMlForCheckup(checkupId);
    }
  });

  return {
    isPending,
    error,
    mlForCheckup
  };
};
